import { datadogRum } from '@datadog/browser-rum';
import type {
  ApplicationLogContext,
  ErrorContext,
  LogContext,
  Logger,
  LoggerConfig,
} from '../logger/logger';

const loadDatadogRUM = ({
  environment,
  enabled,
  buildVersion,
}: DatadogLoggerConfig) => {
  datadogRum.init({
    applicationId: 'bd954aaf-ab9c-4667-b3c9-ec3a5f809157',
    clientToken: 'pubf761172c2f1b71a35f635bae2364ee2b',
    site: 'datadoghq.com',
    service: 'hirer-product-purchase-ui',
    version: buildVersion,
    env: environment,
    sessionSampleRate: enabled ? 100 : 0,
    trackUserInteractions: true,
    allowedTracingUrls: [
      'https://talent.seek.com.au',
      'https://talent.seek.co.nz',
      'https://talent.staging.seek.com.au',
      'https://talent.staging.seek.co.nz',
      /http:\/\/hirer-graphql-api-.*\.hirer\.dev\.outfra\.xyz/,
    ],
  });
};

const configureDatadogGlobalTags = (
  context: Partial<ApplicationLogContext>,
) => {
  const tags = {
    ...datadogRum.getGlobalContext(),
    ...context,
  };
  datadogRum.setGlobalContext(tags);
};

interface DatadogLoggerConfig extends LoggerConfig {
  enabled?: boolean;
}

const createDatadogLogger = ({
  environment,
  buildVersion,
  enabled = true,
}: DatadogLoggerConfig): Logger => {
  loadDatadogRUM({ environment, enabled, buildVersion });

  return Object.freeze({
    info: (message: string, context: LogContext) =>
      datadogRum.addAction(context.activity ?? message, {
        ...context,
        message,
      }),
    error: (message: string, context: ErrorContext | undefined) => {
      const error = context?.error ?? new Error(message);
      datadogRum.addError(error, {
        ...context,
        message,
      });
    },
    configureApplicationContext: configureDatadogGlobalTags,
  });
};

export { createDatadogLogger };
